'use strict';

function PerformanceReviewRoundController(performanceReviewService, $location, $q, $modal, $datepicker, $timepicker, userService, $log, $window) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.showRound = showRound;
  vm.showRoundModal = showRoundModal;
  vm.showDeleteModal = showDeleteModal;
  vm.deleteRound = deleteRound;
  vm.createRound = createRound;
  vm.formChanged = formChanged;

  vm._requestAll = _requestAll;
  vm._refreshRounds = _refreshRounds;

  vm.indexToRemove = 0;
  vm.dataToRemove = {};
  vm.dateFormat = $datepicker.defaults.dateFormat;
  vm.timeFormat = $timepicker.defaults.timeFormat;
  vm.tabs = [
    {
      name: 'assessment_round',
      icon: 'fa-briefcase',
      titletext: 'round.performance.review.rounds.head',
      leadtext: 'round.performance.review.rounds.lead'
    },
    {
      name: 'round.performance.review.employees',
      icon: 'fa-users',
      titletext: 'round.performance.review.employees.head',
      leadtext: 'round.performance.review.employees.lead'
    }
  ];
  vm.selectedTab = vm.tabs[0];
  $log.log(vm);

  function $onInit(response) {
    $window.location = 'manager/assessment/round-management/';
    return;
    performanceReviewService.list.recentRounds().then(function (result) {
      vm.employees = result.data;
    });

    vm._refreshRounds(response);
  }

  function _requestAll() {
    performanceReviewService.list
      .round(vm.round)
      .then(vm._refreshRounds);
  }

  function _refreshRounds(response) {
    vm.rounds = (response || vm).data.rounds;

    var deleteableRound = {
      canBeDeleted: true
    };

    var roundsWithInvites = vm.rounds
      .map(function (round) {
        return performanceReviewService.list
          .invite(round.id)
          .then(function (invites) {

            if (invites.data.invites.length === 0 && invites.data.invited.length === 0) {
              var roundThatCanBeDeleted = angular.copy(round);
              return angular.extend(roundThatCanBeDeleted, round, deleteableRound);
            }
            return round;
          });
      });

    $q.all(roundsWithInvites).then(function (rounds) {
      vm.rounds = rounds;
    });

    return response;
  }

  function showRound(_, round) {
    return $location.path(performanceReviewService.urls.invite.base({round: round.id}));
  }

  function showRoundModal(index, data) {
    var modal = $modal({template: require('./performance-review-round.edit.modal.html'), show: true});

    modal.$scope.data = data;
    modal.$scope.data.questionnaires = vm.data.questionnaires;
    modal.$scope.submit = function editRound(questionnaire, description, goals) {
      return performanceReviewService.update
        .round(data.id, questionnaire.id, description, goals)
        .then(performanceReviewService.list.round)
        .then($onInit)
        .then(modal.hide);
    };

    modal.$scope.change = function (questionnaire, description, id) {
      if (data.description === description) {
        return $q.resolve();
      }
      return formChanged(questionnaire, description, id);
    };

    modal.$scope.reset = function () {
      modal.hide();
      return $q.resolve;
    };
  }

  function showDeleteModal(index, data) {
    vm.deleteModal = $modal({
      template: require('./performance-review-round.delete.modal.html'),
      show: true
    });
    vm.indexToRemove = index;
    vm.dataToRemove = data;
    vm.deleteModal.$scope.submit = deleteRound;
  }

  function deleteRound() {
    performanceReviewService.delete
      .round(vm.dataToRemove.id)
      .then(vm._requestAll)
      .finally(vm.deleteModal.$scope.$hide());
  }

  function formChanged(questionnaire, description) {
    return vm.rounds.some(function hasRound(round) {
      return round.description === description;
    }) ? $q.reject()
      : $q.resolve();
  }

  function createRound(questionnaire, description, goals) {
    return performanceReviewService.create
      .round(questionnaire.id, description, goals)
      .then(performanceReviewService.list.round)
      .then($onInit);
  }
}

module.exports = PerformanceReviewRoundController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-round/performance-review-round.controller.js
 ** module id = 266
 ** module chunks = 0
 **/